import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import DisplayText, { TextVariant } from "./DisplayText";
import Tooltip, { Pointing } from "./Tooltip";
import clsx from "clsx";
var useStyles = createUseStyles(function (theme) {
    var _a, _b;
    return ({
        appBarSpacer: (_a = {
                minHeight: 48
            },
            _a[theme.breakpoints.up("sm")] = {
                minHeight: 64,
            },
            _a),
        toolbar: (_b = {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "flex-start",
                backgroundColor: "#4398F9",
                height: 48,
                boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"
            },
            _b[theme.breakpoints.up("sm")] = {
                height: 64,
            },
            _b),
        lobbyCode: {
            cursor: "pointer"
        },
        containerBase: {
            position: "relative",
            backgroundColor: theme.color.primary.main,
            width: "25%",
            marginTop: 8,
            display: "flex",
            alignItems: "center",
            "&:after": {
                content: "''",
                position: "absolute",
                backgroundColor: theme.color.primary.main,
                top: 0,
                bottom: 0,
                width: 35,
            }
        },
        leftContainer: {
            paddingLeft: 30,
            "&:after": {
                right: -20,
                transform: "skew(30deg)",
            }
        },
        rightContainer: {
            paddingRight: 30,
            display: "flex",
            justifyContent: "flex-end",
            "&:after": {
                left: -20,
                transform: "skew(-30deg)",
            }
        },
        centerContainer: {
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }
    });
});
var AppBar = function (_a) {
    var title = _a.title, joinCode = _a.joinCode, children = _a.children;
    var classes = useStyles();
    var _b = useState("Click to Copy Join URL"), tooltipText = _b[0], setTooltipText = _b[1];
    function copyCode() {
        if (window && (navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
            navigator.clipboard.writeText("".concat(window.location.origin, "/j/").concat(joinCode)).then(function () {
                setTooltipText("Copied!");
            }).catch(function () {
                setTooltipText("Uh oh. Couldn't copy.");
            });
        }
        else {
            setTooltipText("Uh oh. Couldn't copy.");
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.toolbar },
            React.createElement("div", { className: clsx(classes.leftContainer, classes.containerBase) },
                React.createElement(DisplayText, { variant: TextVariant.s28reg, color: "white" }, title)),
            React.createElement("div", { className: classes.centerContainer }, children),
            React.createElement("div", { className: clsx(classes.rightContainer, classes.containerBase) }, joinCode &&
                React.createElement(DisplayText, { variant: TextVariant.s20med, fontWeight: 400, color: "white" },
                    "Join using the code ",
                    React.createElement(Tooltip, { tip: tooltipText, pointing: Pointing.Right },
                        React.createElement("strong", { onClick: copyCode, className: classes.lobbyCode, "data-qa": "lobby-code" }, joinCode))))),
        React.createElement("div", { className: classes.appBarSpacer })));
};
export default AppBar;
//# sourceMappingURL=AppBar.js.map